import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiRequest } from '../../../APIClient';
import { onboardingSelector } from '../../../reducers/onboarding';

// on mount, fetch products once if it hasn't been fetched before
export const useFetchProducts = () => {
  const hasFetched = useSelector(
    onboardingSelector.hasFetchedOnboardingProducts,
  );

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched) {
      dispatch(apiRequest.getOnboardingProducts());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
